import { render } from "./tipPopup.vue?vue&type=template&id=140922e4&scoped=true"
import script from "./tipPopup.vue?vue&type=script&setup=true&lang=js"
export * from "./tipPopup.vue?vue&type=script&setup=true&lang=js"

import "./tipPopup.vue?vue&type=style&index=0&id=140922e4&scoped=true&lang=scss"

import exportComponent from "/var/jenkins_home/workspace/feiniao-farm-h5-demo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-140922e4"],['__file',"src/components/popup/tipPopup.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "140922e4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('140922e4', __exports__)) {
    api.reload('140922e4', __exports__)
  }
  
  module.hot.accept("./tipPopup.vue?vue&type=template&id=140922e4&scoped=true", () => {
    api.rerender('140922e4', render)
  })

}


export default __exports__